import React from 'react';
import { apiClient } from '../../../lib/apiClient';

export interface SelfServicePublisherRow {
  slug: string;
  name: string;
  rev_share_percent: number;
  stripe_account_id: string | null;
  stripe_payouts_enabled: boolean;
  stripe_details_submitted: boolean;
}

interface StationApiResponse {
  slug: string;
  name: string;
  revSharePercent: number;
  stripe: {
    accountId: string | null;
    payoutsEnabled: boolean;
    detailsSubmitted: boolean;
  };
}

export function useSelfServicePublisher(slug: string | undefined) {
  const [row, setRow] = React.useState<SelfServicePublisherRow | null>(null);
  const [loading, setLoading] = React.useState(true);

  const refresh = React.useCallback(async () => {
    if (!slug) { setLoading(false); return; }
    try {
      const data = await apiClient.get<StationApiResponse>(`/stations/${encodeURIComponent(slug)}`);
      setRow({
        slug: data.slug,
        name: data.name,
        rev_share_percent: data.revSharePercent,
        stripe_account_id: data.stripe.accountId,
        stripe_payouts_enabled: data.stripe.payoutsEnabled,
        stripe_details_submitted: data.stripe.detailsSubmitted,
      });
    } catch {
      setRow(null);
    } finally {
      setLoading(false);
    }
  }, [slug]);

  React.useEffect(() => { refresh(); }, [refresh]);

  return { row, loading, refresh };
}
